import { render } from "./Content.vue?vue&type=template&id=f9356e5c&scoped=true"
const script = {}

import "./Content.vue?vue&type=style&index=0&id=f9356e5c&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9356e5c"]])

export default __exports__